
import { Checkbox, Autocomplete, Backdrop, CircularProgress, BottomNavigation, BottomNavigationAction, Box, Snackbar, Button, Card, Typography, TextField, Grid, FormControlLabel, Switch, Select, FormControl, InputLabel, MenuItem, CardHeader, CardContent, Paper, useMediaQuery, useTheme } from '@mui/material';
import { useState, Fragment, useEffect } from 'react';

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';



import OficialesFind from './OficialesFind';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import axios from "../api/axios"

import SaveAltIcon from '@mui/icons-material/SaveAlt';
import AddCardIcon from '@mui/icons-material/AddCard';
import SearchIcon from '@mui/icons-material/Search';

import OficialesFindLista from './OficialesFindLista';

export default function Oficiales(props) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [id, setId] = useState(0);
    const [nombre, setNombre] = useState("")
    const [inactivo, setInactivo] = useState(false)
    const [mensaje, setMensaje] = useState("")
    const [cuenta, setCuenta] = useState("")
    const [cuentaBanco, setCuentaBanco] = useState(0)
    const [procesando, setProcesando] = useState(false)

    const [openBusqueda, setOpenBusqueda] = useState(false)

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    useEffect(() => {
        let cual = props.cual || 0;
        inicio(cual)
    }, [])




    const handleClick = () => {
        if (puedeGrabar()) {
            grabar();
        }
    }

    const grabar = async () => {
        setProcesando(true)

        try {
            const respuesta = await axios.post("oficiales/grabar", {
                cual: id,
                nombre: nombre,
                cuenta_banco: cuentaBanco,
                cuenta: cuenta,
                inactivo: (inactivo ? -1 : 0)
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            let data = respuesta.data;
            if (data.respuesta == "S") {
                setMensaje("Datos grabados exitosamente")
                inicio(0)
            } else {
                setMensaje(data.mensaje)
            }

        } catch (error) {
            setMensaje(error.message)
        }
        setProcesando(false)
    }

    const puedeGrabar = () => {
        let resultado = true;
        if (nombre.length == 0) { setMensaje("Debe digitar el Nombre"); return false; }


        return resultado;
    }
    const handleCloseMensaje = () => {
        setMensaje("")
    }
    const actionMsg = (
        <Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseMensaje}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </Fragment>
    );

    const handleClickBuscar = () => {
        setOpenBusqueda(true)
    }

    const handleCerrarBusqueda = () => {
        setOpenBusqueda(false)
    }

    const handleSeleccionBusqueda = (cual) => {
        inicio(cual)
        setOpenBusqueda(false)

    }

    const blanquea = () => {
        setId(0)
        setNombre("")
        setCuenta("")
        setCuentaBanco(0)
        setInactivo(false)
    }

    const inicio = async (cual) => {
        blanquea();
        if (cual == 0) { return }

        setProcesando(true)
        try {
            const respuesta = await axios.post("oficiales/inicio", {
                cual: cual
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            const data = respuesta.data;
            //console.log("iniicio", data)
            setId(cual)
            setNombre(data.nombre)
            setCuenta(data.cuenta)
            setCuentaBanco(data.cuenta_banco)
            setInactivo(data.inactivo !== 0 ? true : false)


        } catch (error) {

        }
        setProcesando(false)
    }

    const objWait = () => {
        return (
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={procesando}
                onClick={() => { setProcesando(false) }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        )
    }

    return (
        <Box sx={{
            minHeight: "100vh",
            backgroundColor: '#fafafb',
            p: isMobile ? 1 : 2,
            display: 'flex',
            justifyContent: 'center',
            alignItems: isMobile ? 'flex-start' : 'flex-start',
            pt: isMobile ? 1 : 3
        }}>
            {objWait()}
            {openBusqueda && <OficialesFindLista open={openBusqueda} cerrar={handleCerrarBusqueda} seleccion={handleSeleccionBusqueda} />}
            <Snackbar
                open={mensaje.length == 0 ? false : true}
                autoHideDuration={6000}
                onClose={handleCloseMensaje}
                action={actionMsg}
                message={mensaje}
                sx={isMobile ? { bottom: 70 } : {}}
            />
            <Paper
                elevation={isMobile ? 6 : 3}
                sx={{
                    width: '100%',
                    maxWidth: isMobile ? '100%' : { sm: '100%', md: 520, lg: 650, xl: 750 },
                    minHeight: 'auto',
                    margin: 0,
                    borderRadius: isMobile ? '12px' : '10px',
                    background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                    boxShadow: isMobile ? '0 8px 32px rgba(30, 58, 95, 0.12)' : '0 6px 24px rgba(30, 58, 95, 0.12)',
                    border: '1px solid rgba(30, 58, 95, 0.1)',
                    p: 0,
                    overflow: 'auto'
                }}
            >

                <Box sx={{
                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                    borderRadius: isMobile ? '12px 12px 0 0' : '10px 10px 0 0',
                    borderBottom: isMobile ? '3px solid #d4af37' : '3px solid #d4af37',
                    py: isMobile ? 1.5 : 1.5,
                    px: isMobile ? 1.5 : 2
                }}>
                    <Typography
                        variant='h6'
                        sx={{ color: "white", textAlign: "center", fontWeight: 600, letterSpacing: 0.5 }}
                    >
                        Oficiales
                    </Typography>
                </Box>
                <BottomNavigation
                    sx={{
                        mb: isMobile ? 1 : 1,
                        height: isMobile ? 56 : 52,
                        minHeight: isMobile ? 56 : 52,
                        '& .MuiBottomNavigationAction-root': {
                            minWidth: isMobile ? 'auto' : 80,
                            padding: isMobile ? '6px 12px' : '6px 12px',
                            minHeight: isMobile ? 56 : 52,
                        },
                        '& .MuiBottomNavigationAction-label': {
                            fontSize: isMobile ? '0.75rem' : '0.8rem'
                        },
                        '& .MuiSvgIcon-root': {
                            fontSize: isMobile ? '1.5rem' : '1.4rem'
                        }
                    }}
                    showLabels
                    onChange={(event, newValue) => {
                        if (newValue === 0) { inicio(0) }
                        if (newValue === 1) { handleClick() }
                        if (newValue === 2) { handleClickBuscar() }
                    }}
                >
                    <BottomNavigationAction label="Nuevo" icon={<SaveAltIcon />} />
                    <BottomNavigationAction label="Grabar" icon={<AddCardIcon />} />
                    <BottomNavigationAction label="Buscar" icon={<SearchIcon />} />
                </BottomNavigation>

                <Box padding={isMobile ? 1.5 : 2.5}>
                    <Grid container spacing={isMobile ? 1.5 : 2}>
                        <Grid item xs={8}>
                            <TextField
                                fullWidth
                                size={isMobile ? "small" : "medium"}
                                label="Nombre"
                                autoComplete='off'
                                value={nombre}
                                onChange={(event) => { setNombre(event.target.value.toUpperCase()) }}
                                variant="outlined"
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <FormControlLabel
                                control={<Switch checked={inactivo} onChange={(event) => setInactivo(event.target.checked)} />}
                                label={<Typography sx={{ fontSize: isMobile ? '0.85rem' : '0.9rem' }}>Inactivo</Typography>}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                size={isMobile ? "small" : "medium"}
                                label="Cuenta Banco"
                                autoComplete='off'
                                value={cuenta}
                                onChange={(event) => { setCuenta(event.target.value.toUpperCase()) }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth size={isMobile ? "small" : "medium"}>
                                <InputLabel id="label-banco">Banco:</InputLabel>
                                <Select
                                    labelId="labelbanco"
                                    id="cuentaBanco"
                                    label="Tipo Banco"
                                    value={cuentaBanco}
                                    onChange={(event) => { setCuentaBanco(event.target.value) }}
                                >
                                    <MenuItem value={0}>(Seleccione)</MenuItem>
                                    <MenuItem value={1}>BHD</MenuItem>
                                    <MenuItem value={2}>Reservas</MenuItem>
                                    <MenuItem value={5}>Popular</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                </Box>


            </Paper>
        </Box>

    )
}